module.exports = __webpack_public_path__ + "static/media/bord-gais-energy.f043fa7e.png";